export default {
  // GLOBAL
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description': "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text': 'Nessun elemento disponibile',
  'global#facet_loading_text': 'Caricamento...',

  // READMORE
  'readmore#label': 'Mostra tutto',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',

  // SEARCH
  // Page title
  'search#title_records': 'Risorse',
  'search#title_works': 'Opere',
  'search#title_witnesses': 'Testimoni',
  'search#title_bibliographies': 'Bibliografia',
  'search#title_biographies': 'Vite antiche',
  'search#title_iconographies': 'Iconografia',
  'search#title_tools': 'Materiali e strumenti',
  // Total results
  'search#records_total': '<strong>{ total }</strong> Risorse',
  'search#records_total_1': '<strong>{ total }</strong> Risorsa',
  'search#records_total_0': 'Nessuna Risorsa',
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#bibliographies_total': '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1': '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  // Facets
  'search#facets_title': 'Filtra i risultati',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#placeholder_authors': 'Cerca un autore',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  // Order
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  // Results
  'search#filters_title': 'Filtri attivi:',
  'search#fallback_text': 'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_text': 'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_button': 'Resetta la ricerca',
  'search#resultsamount': 'Risultati per pagina',
  // Description
  'search#description_button': 'Info',
  'search#description_link': 'Chiudi',

  // RESOURCE
  'resource#authors': 'di',
  'resource#author': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'resource#collection_witness': 'Testimoni collegati',
  'resource#bibliography': 'Bibliografia',
  
  // ADVANCED SEARCH
  'advancedsearch#title': 'Ricerca avanzata',
  'advancedsearch#results_title': 'Risultati',
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#reset': 'Pulisci i campi',
  'advancedsearch#results_total': '<strong>{ total }</strong> risultati',
  'advancedsearch#results_total_1': '<strong>{ total }</strong> risultato',
  'advancedsearch#results_total_0': 'Nessun risultato',
  'advancedsearch#results_number': 'Risultati per pagina',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#label_title': 'Titolo',

  // ITINERARY
  'itinerary#related_res_title': 'Related itineraries',
};
